"use client";

import { TextResources } from "@portal/assets/text/TextResources";
import Button from "@portal/components/atoms/v2/buttons/button";
import { useRouter } from "next/navigation";

const ReloadButton = () => {
  const router = useRouter();
  return (
    <Button
      text={TextResources.NO_ACCESS_TO_FEATURE_GO_TO_MAIN_PAGE_BUTTON_TEXT}
      wide
      onClick={() => {
        router.push("/");
      }}
    />
  );
};

export default ReloadButton;
